__turbopack_context__.v({
  "className": "figtree_49cec886-module__S-xelW__className",
  "variable": "figtree_49cec886-module__S-xelW__variable",
});
